// extracted by mini-css-extract-plugin
export default {"outerContainer":"shared_outerContainer__so0FY"};